module.exports = __webpack_public_path__ + "img/whittard_Gen.164cf5d3.jpg";